import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentTitle from 'react-document-title';

interface Props {
    title: string;
    children?: React.ReactChild | React.ReactChild[] | null;
} 

const ScreenTitle: React.FunctionComponent<Props> = ({ children, title }: Props) => {
    const { t } = useTranslation();

    return (
        <DocumentTitle title={(title ? (title + ' - ') : '' )+ t('app.name')}>
            <>{children}</>
        </DocumentTitle>
    );
}

export default ScreenTitle;
